import React from 'react';
import StarHalf from '../icons/material-symbols/star_half';
import Star from '../icons/material-symbols/star';

export interface StarsProps {
  rating: number;
  i: number;
}

export const StarsRate = (props: StarsProps) => {
  const { rating, i } = props;

  let color = '#FFC700';
  if (i >= rating + 1) {
    color = 'var(--theme-palette-dark-white)';
  }

  if (i > rating && i < rating + 1) {
    return <StarHalf width={25} height={25} color={color} />;
  }

  return <Star width={25} height={25} color={color} />;
};
